/**
 * 技术专家路由配置
 */
export default [
    {
        path: 'technician/jszj',
        component: resolve => require(['@/views/technician'], resolve),
        name: 'technician',
        meta: {
            nav:'技术专家'
        }
    }
 ]



// WEBPACK FOOTER //
// ./src/router/technician.js